module.exports = __webpack_public_path__ + "static/media/twoContent.f6aaf2a0.png";